export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "download_linkedin_application": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Télécharger l'extension Nomination pour LinkedIn"])},
        "not_yet_subscribed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pas encore abonné ?"])},
        "request_demo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Demander une démo"])}
      },
      "en": {
        
      }
    }
  })
}
